export type TicketTypeKeys =
  | 'selector_tickets_and_passes_title'
  | 'selector_flexible_title'
  | 'selector_pay_as_you_go_title';

export interface TicketSelectorOption {
  titleKey: TicketTypeKeys;
  descriptionKey: string;
}
